import React from 'react';
import { Popover } from 'antd';
import { PopoverProps } from 'antd/lib/popover';
import './Popover.less';

const TPopover: React.FC<PopoverProps> = ({ children, ...props }) => {
  return (
    <Popover
      {...props}
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
    >
      {children}
    </Popover>
  );
};

export default TPopover;
